import { cannot } from '@/app/helpers'
import { PersonalizationType, PzGroup, SinglePersonalizationType } from '@/app/types'

export type PzMetadata = SinglePersonalizationType & { group: PzGroup }

export const getPzCatalog = (list: PersonalizationType): PzMetadata[] =>
  (Object.keys(list) as PzGroup[]).flatMap((group) => (list[group] ?? []).map((item) => ({ ...item, group })))

export const getGroupTitle = (key: PzGroup) => {
  switch (key) {
    case PzGroup.API:
      return 'API fields'
    case PzGroup.Contact:
      return 'Contact fields'
    case PzGroup.CustomFields:
      return 'Custom fields'
    case PzGroup.Groups:
      return '# of contacts in group'
    case PzGroup.Message:
      return 'Messages'
    case PzGroup.Segments:
      return '# of contacts in segment'
    case PzGroup.PartResponses:
      return 'Part responses'
    default:
      return cannot(key)
  }
}
